var _defs, _path, _circle, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogoSigpermonSimple = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Signal_and_Performance_Monitoring",
    viewBox: "0 0 134.54 156.85",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.88 0H48.03L27.1 36.24l20.93 36.24h41.85l20.93-36.24L89.88 0Z",
    className: "sig-5"
  })), /*#__PURE__*/React.createElement("style", null, "\r\n      .sig-5,.sig-6{fill:none}.sig-6{stroke:#f6f6f5;stroke-linejoin:round;stroke-width:3px}.sig-7{fill:#0066b0}.sig-8{fill:#f5f5f5}.sig-9{fill:#f6f6f5}\r\n    "))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.09 1.84h39.72l19.86 34.4-19.86 34.4H49.09l-19.86-34.4 19.86-34.4z",
    className: "sig-7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 78.57,
    cy: 100.87,
    r: 55.03,
    className: "sig-9",
    transform: "rotate(-45 78.565 100.877)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78.57 46.79c29.82 0 54.08 24.26 54.08 54.08s-24.26 54.08-54.08 54.08-54.08-24.26-54.08-54.08 24.26-54.08 54.08-54.08m0-1.89c-30.91 0-55.97 25.06-55.97 55.97s25.06 55.97 55.97 55.97 55.97-25.06 55.97-55.97S109.48 44.9 78.57 44.9ZM71.17 15.93l-27.29 4.6c-1.1.19-2.15-.56-2.33-1.66s.56-2.15 1.66-2.33l27.29-4.6c1.1-.19 2.15.56 2.33 1.66.19 1.1-.56 2.15-1.66 2.33Z",
    className: "sig-9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m52.577 12.38 7.701-1.299 1.523 9.033-7.701 1.298z",
    className: "sig-9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m58.25 22.2.37 1.45",
    className: "sig-6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m59.13 25.63 2.05 7.91",
    style: {
      strokeDasharray: "0 0 0 0 0 0 2.04 0 0 2.04 2.04 2.04",
      stroke: "#f6f6f5",
      strokeLinejoin: "round",
      strokeWidth: 3,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61.18 33.54 3.08 11.88",
    style: {
      stroke: "#f6f6f5",
      strokeLinejoin: "round",
      strokeWidth: 3,
      fill: "none",
      strokeDasharray: "0 0 0 0 0 0 2.04 2.04 2.04 0 0 2.04"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m64.26 45.42.37 1.45",
    className: "sig-6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m94.73 23.6-27.29 4.6c-1.1.19-2.15-.56-2.33-1.66s.56-2.15 1.66-2.33l27.29-4.6c1.1-.19 2.15.56 2.33 1.66.19 1.1-.56 2.15-1.66 2.33Z",
    className: "sig-9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m76.133 20.036 7.7-1.298 1.524 9.032-7.701 1.299z",
    className: "sig-9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m81.8 29.87-.6 1.37",
    className: "sig-6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m80.35 33.17-3.38 7.73",
    style: {
      strokeDasharray: "0 0 0 0 0 0 2.11 0 0 2.1 2.11 2.1",
      stroke: "#f6f6f5",
      strokeLinejoin: "round",
      strokeWidth: 3,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.97 40.9 71.9 52.49",
    style: {
      strokeDasharray: "0 0 0 0 0 0 2.11 2.11 2.11 0 0 2.1",
      stroke: "#f6f6f5",
      strokeLinejoin: "round",
      strokeWidth: 3,
      fill: "none"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m71.9 52.49-.6 1.38",
    className: "sig-6"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M61.72 19.03h44.27v42.15H61.72z",
    className: "sig-5"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M63.11 53.4h3.28v16.84h-3.28zM72.78 48.49h3.28v21.75h-3.28zM67.93 56.87h3.28v13.37h-3.28z",
    className: "sig-7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.76 70.08c-.08 0-.15-.02-.23-.05l-7.71-3.74-9.31-.06a.514.514 0 1 1 .01-1.03l9.42.06c.08 0 .15.02.22.05l7.34 3.56 2.95-6.62c.08-.19.27-.31.47-.31h7.98l3.57-3.08c.16-.13.38-.16.56-.07l5.93 2.88c.07.03.13.08.17.14l2.58 3.16 5.76-.99 4.71-7.04c.12-.18.34-.26.54-.22.21.05.37.21.4.42l1.27 8.01 1.81-.12 1.25-3.84c.04-.12.12-.22.23-.29l6.45-3.71c.25-.14.56-.06.7.19.14.25.06.56-.19.7l-6.28 3.61-1.3 3.98c-.07.2-.25.34-.46.35l-2.63.18c-.26.03-.5-.17-.54-.43l-1.14-7.18-4.1 6.13c-.08.12-.2.2-.34.22l-6.28 1.07a.514.514 0 0 1-.49-.18l-2.7-3.3-5.52-2.68-3.46 2.98c-.09.08-.21.12-.34.12h-7.83l-3.03 6.8c-.06.13-.16.23-.29.27-.06.02-.12.03-.18.03ZM80.55 60.9h11.62c0 3.04-1.26 5.78-3.29 7.74l-8.34-7.74ZM80.82 48.93h-.7c-.16 0-.31.04-.47.05V59.7l2.72-10.61c-.51-.09-1.03-.15-1.55-.16ZM80.55 59.7h11.62c0-4.72-3.04-8.72-7.26-10.18L80.55 59.7Z",
    className: "sig-7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M89.88 0H48.03L27.1 36.24l20.93 36.24h41.85l20.93-36.24L89.88 0Zm-1.07 70.64H49.09l-19.86-34.4 19.86-34.4h39.72l19.86 34.4-19.86 34.4Z",
    className: "sig-9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M48.03 0h41.85l20.92 36.24-20.92 36.25H48.03L27.1 36.24 48.03 0z",
    className: "sig-5"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogoSigpermonSimple);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo-sigpermon-simple.d95ad07810d83fdac53ae766028e204e.svg";